export const project = state => state.project;
export const projectId = state => state.project.id;
export const images = state => state.images;
export const title = state => state.title;
export const description = state => state.description;



// WEBPACK FOOTER //
// ./src/screens/App/store/getters.js